import * as React from "react"
const Apple = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#141313"
        d="M16.053 8.35c-.473-.036-.98.077-1.758.374.066-.025-.742.29-.969.37-.502.175-.915.27-1.378.27-.457 0-.88-.09-1.364-.254a9.883 9.883 0 0 1-.505-.186l-.45-.177c-.647-.254-1.011-.35-1.314-.342-1.153.015-2.243.68-2.877 1.782-1.292 2.244-.576 6.299 1.313 9.03 1.005 1.445 1.556 1.96 1.777 1.954.222-.01.386-.057.784-.225l.166-.071c1.005-.43 1.71-.618 2.77-.618 1.022 0 1.704.186 2.67.602l.168.072c.396.17.54.208.791.202.357-.005.798-.417 1.777-1.854.268-.391.506-.803.71-1.22a7.35 7.35 0 0 1-.39-.347c-1.29-1.228-2.088-2.884-2.11-4.93a6.625 6.625 0 0 1 1.412-4.18 4.124 4.124 0 0 0-1.221-.25l-.002-.001Zm.155-1.993c.709.048 2.737.264 4.057 2.196-.108.06-2.425 1.404-2.4 4.212.036 3.36 2.94 4.476 2.976 4.488-.024.084-.469 1.596-1.537 3.156-.923 1.356-1.883 2.7-3.395 2.724-1.489.036-1.969-.876-3.66-.876-1.705 0-2.232.852-3.636.912-1.464.048-2.568-1.464-3.504-2.808C3.2 17.6 1.749 12.585 3.705 9.189c.972-1.692 2.7-2.76 4.584-2.784 1.428-.036 2.784.96 3.66.96.864 0 2.412-1.152 4.26-1.008Zm-1.14-1.824c-.78.936-2.051 1.668-3.287 1.572-.168-1.272.455-2.604 1.175-3.432.805-.936 2.149-1.632 3.265-1.68.143 1.296-.373 2.604-1.152 3.54Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.276.143h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
)
export default Apple